<template>
  <header
    :class="containerClass"
    class="page-header"
  >
    <MainNavigation
      v-if="hasNav"
      :hide-navi="hideNavi"
    >
      <template #logo><slot name="logo" /></template>
      <template #menu><slot name="menu" /></template>
    </MainNavigation>
    <DialogContainer :with-nav="hasNav" />
  </header>
</template>

<script setup lang="ts">
import DialogContainer from '~/components/flyout-container.vue';
import MainNavigation from '~/components/navigation/main-navigation.vue';

type PageHeaderProps = {
  theme?: string | null;
  hideNavi?: boolean;
};

const props = withDefaults(defineProps<PageHeaderProps>(), {
  theme: null,
  hideNavi: false,
});

const containerClass = computed(() => ({
  [`page-header--${props.theme}`]: !!props.theme,
}));

const hasNav = computed(() => !props.theme);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.page-header {
  position: sticky;
  top: 0;
  z-index: $z-index-header;
  transition: top 0.4s $nav-timing-function;
  // set "flex" to avoid space for the dialog
  display: flex;
  flex-direction: column;

  &--small {
    border-top: 4px solid var(--color-primary);
    @include mq($mq-lg) {
      top: 0;
    }
  }
}

body.nav-scrolled {
  .page-header {
    @include mq($mq-lg) {
      top: $nav-shrink-offset * -1;
    }
  }
}
</style>
